<template>
  <el-drawer
    v-if="visible"
    :title="$l('dialog_title_moq_confirm')"
    :visible="visible"
    direction="rtl"
    show-close
    :size="1200"
    @before-close="close"
    @close="close"
    :wrapper-closable="false"
    :close-on-press-escape="false"
    :append-to-body="false"
  >
    <div class="drawer-main">
      <el-row :gutter="20">
        <el-col :span="7" class="left-box">
          <div v-show="showList">
            <PageHeader
              @closeList="showList = false"
              @query="searchCarList"
            ></PageHeader>
            <el-card
              shadow="never"
              class="c-card"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <div class="card-content" @click="() => checkCard(item, index)">
                <div class="card-information">
                  <div :class="item.error ? 'error' : ''">
                    {{ item.amzMoqName || '' }}
                  </div>
                  <div>{{ item.scmName || '' }}</div>
                  <div>
                    {{ $l('tips_buyerName') || '采购' }}:
                    {{ item.buyerName || '' }}
                  </div>
                  <div>
                    {{ $l('tips_amzMoqUnit') || '起订量单位' }}:
                    {{ item.v_amzMoqUnit || '' }}
                  </div>
                </div>
                <div class="card-progress">
                  <el-progress
                    type="circle"
                    :percentage="item.progress || 0"
                    :width="100"
                  ></el-progress>
                </div>
              </div>
            </el-card>
          </div>
          <div v-if="!showList">
            <div class="c-button">
              <el-button-group>
                <el-button
                  type="primary"
                  icon="el-icon-arrow-left"
                  size="small"
                  :disabled="currIndex <= 0"
                  @click="prePage"
                  >{{ $l('button_pre_page') || '上一页' }}</el-button
                >
                <el-button
                  type="primary"
                  class="ml-2"
                  size="small"
                  :disabled="!hasNext"
                  @click="nextPage"
                  >{{ $l('button_next_page') || '下一页'
                  }}<i class="el-icon-arrow-right el-icon--right"></i
                ></el-button>
              </el-button-group>
              <el-button type="primary" size="small" @click="showList = true">{{
                $l('tips_list_card_page') || '列表页'
              }}</el-button>
            </div>
            <el-card class="c-card" shadow="never">
              <div class="card-content">
                <div class="card-information">
                  <div :class="cardInfo.error ? 'error' : ''">
                    {{ cardInfo.amzMoqName || '' }}
                  </div>
                  <div>{{ cardInfo.scmName || '' }}</div>
                  <div>
                    {{ $l('tips_buyerName') || '采购' }}:
                    {{ cardInfo.buyerName || '' }}
                  </div>
                  <div>
                    {{ $l('tips_amzMoqUnit') || '起订量单位' }}:
                    {{ cardInfo.v_amzMoqUnit || '' }}
                  </div>
                </div>
                <div class="card-progress">
                  <el-progress
                    type="circle"
                    :percentage="cardInfo.progress"
                    :width="100"
                  ></el-progress>
                </div>
              </div>
            </el-card>
            <el-card class="c-p-card" v-if="!pcardListIsEmpty && cardInfo.amzMoqUnit == 'Fabric'" shadow="never">
              <div
                class="card-content"
                v-for="(item, index) in pcardList"
                :key="index"
              >
                <div class="card-information">
                  <div class="lh20">{{ item.fabricNo }}</div>
                  <div class="lh20">{{ item.fabricDisplayName }}</div>
                  <div class="lh20">
                    <span class="mr-4"
                      >{{ $l('tips_moq') || '起订量' }}: {{ item.moq
                      }}{{ item.moqUnit }}</span
                    >
                    <span
                      >{{ $l('tips_actualFlipQuantity') || '当前采购数量' }}:
                      {{ item.purchaseQuantity }}{{ item.moqUnit }}</span
                    >
                  </div>
                  <el-progress
                    :percentage="item.progress"
                    class="lh20"
                    color="#67c23a"
                  ></el-progress>
                </div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :span="17">
          <el-card class="ac-card" shadow="never">
            <div class="title">
              相关产品
            </div>
            <SkuTable
              ref="SkuTable"
              @change="change"
              :disabled="disabledSku"
            ></SkuTable>
          </el-card>
        </el-col>
      </el-row>

      <!-- <span
        slot="footer"
        style="position: absolute;
      right: 20px;
      bottom: 20px;"
        v-if="!pcardListIsEmpty && !disabled"
      >
        <el-button size="small" @click="close()">
          {{ this.$l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="saveConfirm()">
          {{ $l('btn_save_confirm') || '保存并确认翻单' }}
        </el-button>
      </span> -->
    </div>
  </el-drawer>
</template>
<script>
import PageHeader from './header'
import { add, multiply } from '@/libs/util.number.js'
import EditLoading from '@/mixins/edit-loading'
import SkuTable from '../sku-table'
export default {
  mixins: [EditLoading],
  components: { PageHeader, SkuTable },
  props: {
    visible: { type: Boolean, default: false },
    amzFlipOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      cardList: [],
      cardInfo: {},
      showList: false,
      currIndex: -1,
      amzFlipOrderSkuCodes: [],
      tmpForm: {},
    }
  },
  computed: {
    disabledSku() {
      return this.pcardListIsEmpty || this.disabled
    },
    pcardListIsEmpty() {
      return this.pcardList.length <= 0
    },
    pcardList() {
      return this.cardInfo.cardList || []
    },
    hasNext() {
      return this.currIndex < this.cardList.length - 1 && this.currIndex >= 0
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    searchCarList(form) {
      this.tmpForm = { ...form }
      this.$api
        .ecomAmzFlipOrderSkuMoqConfirmApi({
          ...form,
          amzFlipOrderCode: this.amzFlipOrderCode,
        })
        .then((res) => {
          this.cardList = res.body?.data || []
        })
    },
    init() {
      this.$api
        .ecomAmzFlipOrderSkuMoqConfirmApi({
          amzFlipOrderCode: this.amzFlipOrderCode,
        })
        .then((res) => {
          this.cardList = res.body?.data || []
          if (this.cardList && this.cardList.length > 0) {
            this.cardInfo = this.cardList[0]
            this.currIndex = 0
            this.checkCard(this.cardInfo, this.currIndex)
          }
        })
    },
    change(tableData) {
      const quantityMap = {}
      for (let i = 0; i < tableData.length; i++) {
        const tmpData = tableData[i]
        const moqMaterials = tmpData.moqMaterials || []
        const actualFlipQuantity = tmpData.actualFlipQuantity
        moqMaterials.map((item) => {
          const curr = multiply(actualFlipQuantity, item.usageQty)
          quantityMap[item.amzMaterialCode] = add(
            quantityMap[item.amzMaterialCode] || 0,
            curr
          )
        })
      }
      let count = 0
      for (let i = 0; i < this.pcardList.length; i++) {
        this.pcardList[i].purchaseQuantity = quantityMap[this.pcardList[i].amzMaterialCode] || 0

        let moq = this.pcardList[i].moq
        if (this.pcardList[i].purchaseQuantity >= moq) {
          this.pcardList[i].progress = 100
          count += 1
        } else {
          this.pcardList[i].progress = parseInt(
            (this.pcardList[i].purchaseQuantity / moq) * 100 + ''
          )
        }
      }
      if (this.pcardListIsEmpty) {
        this.cardInfo.progress = 0
      } else {
        this.cardInfo.progress = parseInt(
          (count / this.pcardList.length) * 100 + ''
        )
      }
    },
    reloadCardList() {
      this.$api
        .ecomAmzFlipOrderSkuMoqConfirmApi({
          ...this.tmpForm,
          amzFlipOrderCode: this.amzFlipOrderCode,
        })
        .then((res) => {
          this.cardList = res.body?.data || []
          if (this.cardList && this.cardList.length > 0) {
            this.cardInfo = this.cardList[this.currIndex]
            this.checkCard(this.cardInfo, this.currIndex)
          }
        })
    },
    getSkuTabelList() {
      const { tableData } = this.$refs.SkuTable.getTableData()
      return tableData
    },
    close() {
      this.$emit('close')
    },
    saveConfirm() {
      const tableData = this.getSkuTabelList()
      if (this.loadingOpen()) return
      this.$api
        .ecomAmzFlipOrderSkuSaveConfirmApi({
          saveList: tableData,
        })
        .then((res) => {
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.reloadCardList()
          this.loadingClose()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    save() {
      const tableData = this.getSkuTabelList()
      if (this.loadingOpen()) return
      this.$api
        .ecomAmzFlipOrderSkuSaveApi({
          saveList: tableData,
        })
        .then((res) => {
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.reloadCardList()
          this.loadingClose()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    prePage() {
      const item = this.cardList[this.currIndex - 1]
      this.checkCard(item, this.currIndex - 1)
    },
    nextPage() {
      const item = this.cardList[this.currIndex + 1]
      this.checkCard(item, this.currIndex + 1)
    },
    checkCard(item, index) {
      this.cardInfo = { ...item }
      if (item.amzMoqCode) {
        this.$api
          .ecomAmzFlipOrderSkuMoqConfirmPCardListApi({
            amzFlipOrderCode: this.amzFlipOrderCode,
            amzMoqCode: item.amzMoqCode,
          })
          .then((res) => {
            this.cardInfo.cardList = res.body?.data || []
          })
      } else {
        this.cardInfo.cardList = []
      }
      this.currIndex = index
      if (
        this.currIndex > -1 &&
        this.cardList &&
        this.cardList.length > this.currIndex
      ) {
        this.amzFlipOrderSkuCodes = this.cardInfo.amzFlipOrderSkuCodeList || []
        this.$refs.SkuTable.query(this.amzFlipOrderSkuCodes)
      }

      this.showList = false
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 30px 10px;
  position: static;
}
.c-button {
  display: flex;
  justify-content: space-between;
}
.c-card {
  margin-top: 15px;
  font-size: 14px;
  color: #101010;
  border-radius: 10px;
}
::v-deep {
  .ac-card {
    .el-card__body {
      padding: 10px;
    }
  }
  .el-drawer__body {
    background-color: #f1f5f9;
    padding-top: 15px;
  }
}
.ac-card {
  border-radius: 10px;
  .title {
    color: #101010;
    margin: 10px 0 0 10px;
    font-size: 18px;
  }
}
.mt10 {
  margin-top: 10px;
}
.left-box {
  overflow-y: auto;
  overflow-x: clip;
  height: calc(100vh - 110px);
}
.card-content {
  display: flex;
  flex: 1;
  justify-content: space-between;
  .card-information {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;
    margin-right: 10px;
    .error {
      color: rgb(219, 48, 48);
    }
    .lh20 {
      line-height: 20px;
    }
  }

  .card-progress {
    display: flex;
    align-items: center;
  }
}
.c-p-card {
  font-size: 14px;
  color: #101010;
  border-radius: 10px;
}
</style>
